export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";